import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { PermissionService } from 'src/app/_shared/core/services/permission.service';
import { environment } from 'src/environments/environment';
import { DynamicAsideMenuService } from '../../core/services/dynamic-aside-menu.service';
import { LayoutService } from '../../core/services/layout.service';
import { AsideCollapseService } from '../../core/services/asideCollapse.service';
import { LoggerCommonService } from 'src/app/_shared/core/services/logger-common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoachMarksResetModalComponent } from 'src/app/_shared/components/coach-marks-reset-modal/coach-marks-reset-modal.component';
import { ToastService } from 'src/app/_shared/core/services/toast.service';
import { PERMISSION } from 'src/app/_shared/core/constants/permissions-constants';
import { BRANDING, BRANDING_MEDIA } from 'src/app/_shared/core/constants/branding.constants';

@Component({
  selector: 'sc-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss']
})
export class AsideComponent implements OnInit, OnDestroy {
  menuConfig: any;
  subscriptions: Subscription[] = [];

  disableAsideSelfDisplay: boolean;
  headerLogo: string;
  brandSkin: string;
  poweredByLogo: string;
  ulCSSClasses: string;
  asideMenuHTMLAttributes: any = {};
  asideMenuCSSClasses: string;
  asideMenuDropdown;
  brandClasses: string;
  asideMenuScroll = 1;
  asideSelfMinimizeToggle = false;
  asideSelfMinimizeCurrent = false;
  currentUrl: string;
  branding: any = BRANDING;

  @Output() collapsedAside: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private readonly layout: LayoutService,
    private readonly router: Router,
    private readonly menu: DynamicAsideMenuService,
    private readonly permissionService: PermissionService,
    private readonly asideCollapseService: AsideCollapseService,
    private readonly logger: LoggerCommonService,
    private readonly modalService: NgbModal,
    private readonly toastService: ToastService
  ) { }

  ngOnInit(): void {
    // load view settings
    this.disableAsideSelfDisplay =
      this.layout.getProp('aside.self.display') === false;
    this.brandSkin = this.layout.getProp('brand.self.theme');
    this.headerLogo = this.getECAMCentralLogo();
    this.poweredByLogo = this.getECAMLogo();
    this.ulCSSClasses = this.layout.getProp('aside_menu_nav');
    this.asideMenuCSSClasses = this.layout.getStringCSSClasses('aside_menu');
    this.asideMenuHTMLAttributes = this.layout.getHTMLAttributes('aside_menu');
    this.asideMenuDropdown = this.layout.getProp('aside.menu.dropdown') ? '1' : '0';
    this.brandClasses = this.layout.getProp('brand');
    this.asideSelfMinimizeToggle = this.layout.getProp('aside.self.minimize.toggle');
    this.asideSelfMinimizeCurrent = this.layout.getProp('aside.self.minimize.default');
    this.asideMenuScroll = this.layout.getProp('aside.menu.scroll') ? 1 : 0;


    // router subscription
    this.currentUrl = this.router.url.split(/[?#]/)[0];
    const routerSubscr = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.url;
    });
    this.subscriptions.push(routerSubscr);

    // menu load
    const menuSubscr = this.menu.menuConfig$.subscribe(res => {
      this.menuConfig = res;
    });
    this.subscriptions.push(menuSubscr);

    this.getAppVersion();
  }

  hasPermission(permission: string): boolean {
    if (permission == PERMISSION.Pages_Tenant_Dashboard) {
      return this.permissionService.hasDashboardPermission();
    } else {
      return this.permissionService.hasPermission(permission);
    }
  }

  getAppVersion(): string {
    return environment.appVersion;
  }

  private getECAMCentralLogo() {
    return BRANDING_MEDIA.PRODUCT_LIGHT_IMAGE;
  }

  private getECAMLogo() {
    return BRANDING_MEDIA.POWEREDBY_LIGHT_IMAGE;
  }

  isMenuItemActive(path) {
    if (!this.currentUrl || !path) {
      return false;
    }

    if (this.currentUrl === path) {
      return true;
    }

    if (this.currentUrl.indexOf(path) > -1) {
      return true;
    }

    return false;
  }

  toggleAside() {
    this.logger.trackClick(`ToggleAside_${this.asideSelfMinimizeCurrent ? 'Open' : 'Close'}`);
    this.asideSelfMinimizeCurrent = !this.asideSelfMinimizeCurrent;
    this.collapsedAside.emit(this.asideSelfMinimizeCurrent);
    this.asideCollapseService.isAsideMenuCollapsedSubject.next(!this.asideSelfMinimizeCurrent);
  
    const body = document.body;
    if (this.asideSelfMinimizeCurrent) {
      body.classList.add('aside-minimized');
    } else {
      body.classList.remove('aside-minimized');
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  buttonClick(button: string) {
    button = button.split(' ').join('');
    this.logger.trackClick(button);
  }

  getTipsButton() {
    const modal = this.modalService.open(CoachMarksResetModalComponent,  { size: 'sm', centered: true, backdrop: 'static', keyboard: false })

    modal.result.then(() => {
      this.toastService.success(`<b>Coach Marks</b> reset successfully`);
      window.location.reload();
    }).catch((error) => {
      if (error && error != 1) {
        this.toastService.error(`Error while reseting <b>Coach Marks</b>`);
      }
    });
  }

}
